// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.perxis-auto-1_16_13-car-tile {
  /* Typography */
  --perxis-auto-car-tile-font-family-inner: var(
    --perxis-auto-car-tile-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-car-tile-font-size-inner: var(
    --perxis-auto-car-tile-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-car-tile-font-weight-inner: var(
    --perxis-auto-car-tile-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-car-tile-letter-spacing-inner: var(
    --perxis-auto-car-tile-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-car-tile-line-height-inner: var(
    --perxis-auto-car-tile-line-height,
    var(--perxis-auto-root-typography-small-line-height-xxl-inner)
  );
  --perxis-auto-car-tile-text-transform-inner: var(
    --perxis-auto-car-tile-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-car-tile-color-inner: var(
    --perxis-auto-car-tile-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  /* End Typography */
  /* Colors */
  --perxis-auto-car-tile-background-color-inner: var(
    --perxis-auto-car-tile-background-color,
    var(--perxis-auto-root-first-color-inner)
  );
  /* End Colors */
  /* Border */
  --perxis-auto-car-tile-border-radius-inner: var(--perxis-auto-car-tile-border-radius, 16px);
  --perxis-auto-car-tile-border-width-inner: var(--perxis-auto-car-tile-border-width, 0);
  --perxis-auto-car-tile-border-color-inner: var(
    --perxis-auto-car-tile-border-color,
    var(--perxis-auto-root-second-color-inner)
  );
  /* End Border */
  /* Padding */
  --perxis-auto-car-tile-padding-inner: var(
    --perxis-auto-car-tile-padding,
    0 18px var(--perxis-auto-gap-vertical-sky-inner) 18px
  );
  --perxis-auto-car-tile-image-padding-top-inner: var(--perxis-auto-car-tile-image-padding-top, 75%);
  --perxis-auto-car-tile-gallery-padding-top-inner: var(
    --perxis-auto-car-tile-gallery-padding-top,
    var(--perxis-auto-car-tile-image-padding-top-inner)
  );
  --perxis-auto-car-tile-image-padding-left-inner: var(--perxis-auto-car-tile-image-padding-left, 18px);
  --perxis-auto-car-tile-gallery-padding-left-inner: var(
    --perxis-auto-car-tile-gallery-padding-left,
    var(--perxis-auto-car-tile-image-padding-left-inner)
  );
  --perxis-auto-car-tile-image-padding-right-inner: var(--perxis-auto-car-tile-image-padding-right, 18px);
  --perxis-auto-car-tile-gallery-padding-right-inner: var(
    --perxis-auto-car-tile-gallery-padding-right,
    var(--perxis-auto-car-tile-image-padding-right-inner)
  );
  /* End Padding */
  /* Border */
  --perxis-auto-car-tile-image-border-radius-inner: var(--perxis-auto-car-tile-image-border-radius, 16px 16px 0 0);
  --perxis-auto-car-tile-gallery-border-radius-inner: var(
    --perxis-auto-car-tile-gallery-border-radius,
    var(--perxis-auto-car-tile-image-border-radius-inner)
  );
  /* End Border */
  /* Box Shadow */
  --perxis-auto-car-tile-box-shadow-inner: var(--perxis-auto-car-tile-box-shadow, 0px 0px 12px rgba(22, 22, 22, 0.1));
  --perxis-auto-car-tile-hover-box-shadow-inner: var(
    --perxis-auto-car-tile-hover-box-shadow,
    var(--perxis-auto-car-tile-box-shadow-inner)
  );
  /* End Box Shadow */
}
.perxis-auto-1_16_13-car-tile.ant-5_17_0-card {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  font-family: var(--perxis-auto-car-tile-font-family-inner);
  font-size: var(--perxis-auto-car-tile-font-size-inner);
  line-height: var(--perxis-auto-car-tile-line-height-inner);
  font-weight: var(--perxis-auto-car-tile-font-weight-inner);
  text-transform: var(--perxis-auto-car-tile-text-transform-inner);
  letter-spacing: var(--perxis-auto-car-tile-letter-spacing-inner);
  background: var(--perxis-auto-car-tile-background-color-inner);
  color: var(--perxis-auto-car-tile-color-inner);
  border-radius: var(--perxis-auto-car-tile-border-radius-inner);
  border-width: var(--perxis-auto-car-tile-border-width-inner);
  border-color: var(--perxis-auto-car-tile-border-color-inner);
  border-style: solid;
  overflow: hidden;
}
.perxis-auto-1_16_13-car-tile.ant-5_17_0-card-hoverable {
  box-shadow: var(--perxis-auto-car-tile-box-shadow-inner);
}
.perxis-auto-1_16_13-car-tile.ant-5_17_0-card-hoverable:hover {
  box-shadow: var(--perxis-auto-car-tile-hover-box-shadow-inner);
}
.perxis-auto-1_16_13-car-tile.ant-5_17_0-card .ant-5_17_0-card-body {
  height: 100%;
  padding: var(--perxis-auto-car-tile-padding-inner);
  border: none;
  border-radius: 0;
}

.perxis-auto-1_16_13-car-tile-image {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  border-radius: var(--perxis-auto-car-tile-image-border-radius-inner);
}
.perxis-auto-1_16_13-car-tile-image-wrapper {
  position: relative;
  background-position: center;
  width: calc(100% + var(--perxis-auto-car-tile-image-padding-left-inner) + var(--perxis-auto-car-tile-image-padding-right-inner));
  left: calc(var(--perxis-auto-car-tile-image-padding-left-inner) * -1);
}
.perxis-auto-1_16_13-car-tile-image-wrapper::before {
  content: "";
  display: block;
  width: 100%;
  height: 0;
  padding-top: var(--perxis-auto-car-tile-image-padding-top-inner);
  border-radius: var(--perxis-auto-car-tile-image-border-radius-inner);
}
.perxis-auto-1_16_13-car-tile-image-wrapper .perxis-auto-1_16_13-car-tile-image__skeleton.ant-5_17_0-skeleton.ant-5_17_0-skeleton-element {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
}
.perxis-auto-1_16_13-car-tile-image-wrapper .perxis-auto-1_16_13-car-tile-image__skeleton.ant-5_17_0-skeleton.ant-5_17_0-skeleton-element .ant-5_17_0-skeleton-image {
  width: 100%;
  height: 100%;
  border-radius: var(--perxis-auto-car-tile-image-border-radius-inner);
  background: none;
  position: relative;
}

.perxis-auto-1_16_13-car-tile-location {
  /* Typography */
  --perxis-auto-car-tile-location-text-font-family-inner: var(
    --perxis-auto-car-tile-location-text-font-family,
    var(--perxis-auto-root-typography-super-small-font-family-inner)
  );
  --perxis-auto-car-tile-location-text-font-size-inner: var(
    --perxis-auto-car-tile-location-text-font-size,
    var(--perxis-auto-root-typography-super-small-font-size-xxl-inner)
  );
  --perxis-auto-car-tile-location-text-font-weight-inner: var(
    --perxis-auto-car-tile-location-text-font-weight,
    var(--perxis-auto-root-typography-super-small-font-weight-inner)
  );
  --perxis-auto-car-tile-location-text-letter-spacing-inner: var(
    --perxis-auto-car-tile-location-text-letter-spacing,
    var(--perxis-auto-root-typography-super-small-letter-spacing-inner)
  );
  --perxis-auto-car-tile-location-text-line-height-inner: var(
    --perxis-auto-car-tile-location-text-line-height,
    var(--perxis-auto-root-typography-super-small-line-height-xxl-inner)
  );
  --perxis-auto-car-tile-location-text-text-transform-inner: var(
    --perxis-auto-car-tile-location-text-text-transform,
    var(--perxis-auto-root-typography-super-small-text-transform-inner)
  );
  --perxis-auto-car-tile-location-text-color-inner: var(
    --perxis-auto-car-tile-location-text-color,
    var(--perxis-auto-root-typography-color-dark-light-inner)
  );
  --perxis-auto-car-tile-location-icon-color-inner: var(
    --perxis-auto-car-tile-location-icon-color,
    var(--perxis-auto-root-typography-color-light-inner)
  );
  --perxis-auto-car-tile-location-icon-font-size-inner: var(
    --perxis-auto-car-tile-location-icon-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  /* End Typography */
}
.perxis-auto-1_16_13-car-tile-location__text {
  --perxis-auto-typography-super-small-font-family: var(--perxis-auto-car-tile-location-text-font-family-inner);
  --perxis-auto-typography-super-small-font-weight: var(--perxis-auto-car-tile-location-text-font-weight-inner);
  --perxis-auto-typography-super-small-letter-spacing: var(--perxis-auto-car-tile-location-text-letter-spacing-inner);
  --perxis-auto-typography-super-small-text-transform: var(--perxis-auto-car-tile-location-text-text-transform-inner);
  --perxis-auto-typography-color-dark-light: var(--perxis-auto-car-tile-location-text-color-inner);
  --perxis-auto-typography-super-small-font-size-xxs: var(--perxis-auto-car-tile-location-text-font-size-inner);
  --perxis-auto-typography-super-small-font-size-xs: var(--perxis-auto-car-tile-location-text-font-size-inner);
  --perxis-auto-typography-super-small-font-size-sm: var(--perxis-auto-car-tile-location-text-font-size-inner);
  --perxis-auto-typography-super-small-font-size-md: var(--perxis-auto-car-tile-location-text-font-size-inner);
  --perxis-auto-typography-super-small-font-size-lg: var(--perxis-auto-car-tile-location-text-font-size-inner);
  --perxis-auto-typography-super-small-font-size-xl: var(--perxis-auto-car-tile-location-text-font-size-inner);
  --perxis-auto-typography-super-small-font-size-xxl: var(--perxis-auto-car-tile-location-text-font-size-inner);
  --perxis-auto-typography-super-small-line-height-xxs: var(--perxis-auto-car-tile-location-text-line-height-inner);
  --perxis-auto-typography-super-small-line-height-xs: var(--perxis-auto-car-tile-location-text-line-height-inner);
  --perxis-auto-typography-super-small-line-height-sm: var(--perxis-auto-car-tile-location-text-line-height-inner);
  --perxis-auto-typography-super-small-line-height-md: var(--perxis-auto-car-tile-location-text-line-height-inner);
  --perxis-auto-typography-super-small-line-height-lg: var(--perxis-auto-car-tile-location-text-line-height-inner);
  --perxis-auto-typography-super-small-line-height-xl: var(--perxis-auto-car-tile-location-text-line-height-inner);
  --perxis-auto-typography-super-small-line-height-xxl: var(--perxis-auto-car-tile-location-text-line-height-inner);
}
.perxis-auto-1_16_13-car-tile-location__icon {
  --perxis-auto-typography-color-light: var(--perxis-auto-car-tile-location-icon-color-inner);
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-car-tile-location-icon-font-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-car-tile-location-icon-font-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-car-tile-location-icon-font-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-car-tile-location-icon-font-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-car-tile-location-icon-font-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-car-tile-location-icon-font-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-car-tile-location-icon-font-size-inner);
}
.perxis-auto-1_16_13-car-tile-location,
.perxis-auto-1_16_13-car-tile-location .perxis-auto-1_16_13-typography.perxis-auto-1_16_13-text {
  display: inline-flex;
  align-items: center;
}
.perxis-auto-1_16_13-car-tile-location .perxis-auto-1_16_13-typography.perxis-auto-1_16_13-car-tile-location__icon .perxis-auto-1_16_13-icon {
  margin-right: 8px;
}
.perxis-auto-1_16_13-car-tile-location .perxis-auto-1_16_13-car-tile-location__skeleton.ant-5_17_0-skeleton .ant-5_17_0-skeleton-content .ant-5_17_0-skeleton-paragraph {
  margin: 0;
}
.perxis-auto-1_16_13-car-tile-location .perxis-auto-1_16_13-car-tile-location__skeleton.ant-5_17_0-skeleton.ant-5_17_0-skeleton-with-avatar {
  display: flex;
  align-items: center;
}
.perxis-auto-1_16_13-car-tile-location .perxis-auto-1_16_13-car-tile-location__skeleton.ant-5_17_0-skeleton.ant-5_17_0-skeleton-with-avatar .ant-5_17_0-skeleton-header {
  display: flex;
  justify-content: center;
  align-items: center;
}
.perxis-auto-1_16_13-car-tile-location .perxis-auto-1_16_13-car-tile-location__skeleton.ant-5_17_0-skeleton.ant-5_17_0-skeleton-with-avatar .ant-5_17_0-skeleton-header .ant-5_17_0-skeleton-avatar {
  height: 18px;
  width: 18px;
}
.perxis-auto-1_16_13-car-tile-location .perxis-auto-1_16_13-car-tile-location__skeleton .ant-5_17_0-skeleton-paragraph {
  width: 120px;
}

.perxis-auto-1_16_13-car-tile-title {
  /* Typography */
  --perxis-auto-car-tile-title-heading-font-family-inner: var(
    --perxis-auto-car-tile-title-heading-font-family,
    var(--perxis-auto-root-typography-h3-font-family-inner)
  );
  --perxis-auto-car-tile-title-heading-font-size-inner: var(
    --perxis-auto-car-tile-title-heading-font-size,
    var(--perxis-auto-root-typography-h3-font-size-xxl-inner)
  );
  --perxis-auto-car-tile-title-heading-font-weight-inner: var(
    --perxis-auto-car-tile-title-heading-font-weight,
    var(--perxis-auto-root-typography-h3-font-weight-inner)
  );
  --perxis-auto-car-tile-title-heading-letter-spacing-inner: var(
    --perxis-auto-car-tile-title-heading-letter-spacing,
    var(--perxis-auto-root-typography-h3-letter-spacing-inner)
  );
  --perxis-auto-car-tile-title-heading-line-height-inner: var(
    --perxis-auto-car-tile-title-heading-line-height,
    var(--perxis-auto-root-typography-h3-line-height-inner)
  );
  --perxis-auto-car-tile-title-heading-text-transform-inner: var(
    --perxis-auto-car-tile-title-heading-text-transform,
    var(--perxis-auto-root-typography-h3-text-transform-inner)
  );
  --perxis-auto-car-tile-title-heading-color-inner: var(
    --perxis-auto-car-tile-title-heading-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-car-tile-title-description-font-family-inner: var(
    --perxis-auto-car-tile-title-description-font-family,
    var(--perxis-auto-root-typography-main-font-family-inner)
  );
  --perxis-auto-car-tile-title-description-font-size-inner: var(
    --perxis-auto-car-tile-title-description-font-size,
    var(--perxis-auto-root-typography-main-font-size-xxl-inner)
  );
  --perxis-auto-car-tile-title-description-font-weight-inner: var(
    --perxis-auto-car-tile-title-description-font-weight,
    var(--perxis-auto-root-typography-main-font-weight-inner)
  );
  --perxis-auto-car-tile-title-description-letter-spacing-inner: var(
    --perxis-auto-car-tile-title-description-letter-spacing,
    var(--perxis-auto-root-typography-main-letter-spacing-inner)
  );
  --perxis-auto-car-tile-title-description-line-height-inner: var(
    --perxis-auto-car-tile-title-description-line-height,
    var(--perxis-auto-root-typography-main-line-height-inner)
  );
  --perxis-auto-car-tile-title-description-text-transform-inner: var(
    --perxis-auto-car-tile-title-description-text-transform,
    var(--perxis-auto-root-typography-main-text-transform-inner)
  );
  --perxis-auto-car-tile-title-description-color-inner: var(
    --perxis-auto-car-tile-title-description-color,
    var(--perxis-auto-root-typography-color-dark-inner)
  );
  /* End Typography */
}
.perxis-auto-1_16_13-car-tile-title__heading {
  --perxis-auto-typography-h3-font-family: var(--perxis-auto-car-tile-title-heading-font-family-inner);
  --perxis-auto-typography-h3-font-weight: var(--perxis-auto-car-tile-title-heading-font-weight-inner);
  --perxis-auto-typography-h3-letter-spacing: var(--perxis-auto-car-tile-title-heading-letter-spacing-inner);
  --perxis-auto-typography-h3-text-transform: var(--perxis-auto-car-tile-title-heading-text-transform-inner);
  --perxis-auto-typography-color-darkest: var(--perxis-auto-car-tile-title-heading-color-inner);
  --perxis-auto-typography-h3-font-size-xxs: var(--perxis-auto-car-tile-title-heading-font-size-inner);
  --perxis-auto-typography-h3-font-size-xs: var(--perxis-auto-car-tile-title-heading-font-size-inner);
  --perxis-auto-typography-h3-font-size-sm: var(--perxis-auto-car-tile-title-heading-font-size-inner);
  --perxis-auto-typography-h3-font-size-md: var(--perxis-auto-car-tile-title-heading-font-size-inner);
  --perxis-auto-typography-h3-font-size-lg: var(--perxis-auto-car-tile-title-heading-font-size-inner);
  --perxis-auto-typography-h3-font-size-xl: var(--perxis-auto-car-tile-title-heading-font-size-inner);
  --perxis-auto-typography-h3-font-size-xxl: var(--perxis-auto-car-tile-title-heading-font-size-inner);
  --perxis-auto-typography-h3-line-height-xxs: var(--perxis-auto-car-tile-title-heading-line-height-inner);
  --perxis-auto-typography-h3-line-height-xs: var(--perxis-auto-car-tile-title-heading-line-height-inner);
  --perxis-auto-typography-h3-line-height-sm: var(--perxis-auto-car-tile-title-heading-line-height-inner);
  --perxis-auto-typography-h3-line-height-md: var(--perxis-auto-car-tile-title-heading-line-height-inner);
  --perxis-auto-typography-h3-line-height-lg: var(--perxis-auto-car-tile-title-heading-line-height-inner);
  --perxis-auto-typography-h3-line-height-xl: var(--perxis-auto-car-tile-title-heading-line-height-inner);
  --perxis-auto-typography-h3-line-height-xxl: var(--perxis-auto-car-tile-title-heading-line-height-inner);
}
.perxis-auto-1_16_13-car-tile-title__heading.perxis-auto-1_16_13-typography {
  margin-bottom: 4px;
}
.perxis-auto-1_16_13-car-tile-title__description {
  --perxis-auto-typography-main-font-family: var(--perxis-auto-car-tile-title-description-font-family-inner);
  --perxis-auto-typography-main-font-weight: var(--perxis-auto-car-tile-title-description-font-weight-inner);
  --perxis-auto-typography-main-letter-spacing: var(--perxis-auto-car-tile-title-description-letter-spacing-inner);
  --perxis-auto-typography-main-text-transform: var(--perxis-auto-car-tile-title-description-text-transform-inner);
  --perxis-auto-typography-color-dark: var(--perxis-auto-car-tile-title-description-color-inner);
  --perxis-auto-typography-main-font-size-xxs: var(--perxis-auto-car-tile-title-description-font-size-inner);
  --perxis-auto-typography-main-font-size-xs: var(--perxis-auto-car-tile-title-description-font-size-inner);
  --perxis-auto-typography-main-font-size-sm: var(--perxis-auto-car-tile-title-description-font-size-inner);
  --perxis-auto-typography-main-font-size-md: var(--perxis-auto-car-tile-title-description-font-size-inner);
  --perxis-auto-typography-main-font-size-lg: var(--perxis-auto-car-tile-title-description-font-size-inner);
  --perxis-auto-typography-main-font-size-xl: var(--perxis-auto-car-tile-title-description-font-size-inner);
  --perxis-auto-typography-main-font-size-xxl: var(--perxis-auto-car-tile-title-description-font-size-inner);
  --perxis-auto-typography-main-line-height-xxs: var(--perxis-auto-car-tile-title-description-line-height-inner);
  --perxis-auto-typography-main-line-height-xs: var(--perxis-auto-car-tile-title-description-line-height-inner);
  --perxis-auto-typography-main-line-height-sm: var(--perxis-auto-car-tile-title-description-line-height-inner);
  --perxis-auto-typography-main-line-height-md: var(--perxis-auto-car-tile-title-description-line-height-inner);
  --perxis-auto-typography-main-line-height-lg: var(--perxis-auto-car-tile-title-description-line-height-inner);
  --perxis-auto-typography-main-line-height-xl: var(--perxis-auto-car-tile-title-description-line-height-inner);
  --perxis-auto-typography-main-line-height-xxl: var(--perxis-auto-car-tile-title-description-line-height-inner);
}
.perxis-auto-1_16_13-car-tile-title .perxis-auto-1_16_13-car-tile-title__skeleton-title.ant-5_17_0-skeleton-input {
  width: 100%;
  height: 24px;
  margin-bottom: 4px;
}
.perxis-auto-1_16_13-car-tile-title .perxis-auto-1_16_13-car-tile-title__skeleton-description.ant-5_17_0-skeleton-input {
  width: 50%;
  height: 20px;
}

.perxis-auto-1_16_13-car-tile-table {
  /* Typography */
  --perxis-auto-car-tile-table-icon-color-inner: var(
    --perxis-auto-car-tile-table-icon-color,
    var(--perxis-auto-root-typography-color-light-inner)
  );
  --perxis-auto-car-tile-table-icon-size-inner: var(
    --perxis-auto-car-tile-table-icon-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-car-tile-table-text-size-inner: var(
    --perxis-auto-car-tile-table-text-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-car-tile-table-text-line-height-inner: var(
    --perxis-auto-car-tile-table-text-line-height,
    var(--perxis-auto-root-typography-small-line-height-xxl-inner)
  );
  --perxis-auto-car-tile-table-text-color-inner: var(
    --perxis-auto-car-tile-table-text-color,
    var(--perxis-auto-root-typography-color-dark-light-inner)
  );
  /* End Typography */
}
.perxis-auto-1_16_13-car-tile-table__item {
  --perxis-auto-typography-color-light: var(--perxis-auto-car-tile-table-icon-color-inner);
  --perxis-auto-typography-color-dark-light: var(--perxis-auto-car-tile-table-text-color-inner);
  display: flex;
  align-items: center;
}
.perxis-auto-1_16_13-car-tile-table__item:not(:last-child) {
  margin-bottom: 4px;
}
.perxis-auto-1_16_13-car-tile-table__item-icon {
  --perxis-auto-icon-font-size: var(--perxis-auto-car-tile-table-icon-size-inner);
}
.perxis-auto-1_16_13-car-tile-table__item-text {
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-car-tile-table-text-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-car-tile-table-text-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-car-tile-table-text-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-car-tile-table-text-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-car-tile-table-text-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-car-tile-table-text-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-car-tile-table-text-size-inner);
  --perxis-auto-typography-small-line-height-xxs: var(--perxis-auto-car-tile-table-text-line-height-inner);
  --perxis-auto-typography-small-line-height-xs: var(--perxis-auto-car-tile-table-text-line-height-inner);
  --perxis-auto-typography-small-line-height-sm: var(--perxis-auto-car-tile-table-text-line-height-inner);
  --perxis-auto-typography-small-line-height-md: var(--perxis-auto-car-tile-table-text-line-height-inner);
  --perxis-auto-typography-small-line-height-lg: var(--perxis-auto-car-tile-table-text-line-height-inner);
  --perxis-auto-typography-small-line-height-xl: var(--perxis-auto-car-tile-table-text-line-height-inner);
  --perxis-auto-typography-small-line-height-xxl: var(--perxis-auto-car-tile-table-text-line-height-inner);
}
.perxis-auto-1_16_13-car-tile-table__item-icon.perxis-auto-1_16_13-typography.perxis-auto-1_16_13-text, .perxis-auto-1_16_13-car-tile-table__item-text.perxis-auto-1_16_13-typography.perxis-auto-1_16_13-text {
  display: inline-flex;
  align-items: center;
}
.perxis-auto-1_16_13-car-tile-table__item-icon.perxis-auto-1_16_13-typography.perxis-auto-1_16_13-text .perxis-auto-1_16_13-icon {
  margin-right: 8px;
}
.perxis-auto-1_16_13-car-tile-table .perxis-auto-1_16_13-car-tile-table__skeleton.ant-5_17_0-skeleton .ant-5_17_0-skeleton-content .ant-5_17_0-skeleton-paragraph {
  margin: 0;
}
.perxis-auto-1_16_13-car-tile-table .perxis-auto-1_16_13-car-tile-table__skeleton.ant-5_17_0-skeleton.ant-5_17_0-skeleton-with-avatar {
  display: flex;
  align-items: center;
}
.perxis-auto-1_16_13-car-tile-table .perxis-auto-1_16_13-car-tile-table__skeleton.ant-5_17_0-skeleton.ant-5_17_0-skeleton-with-avatar .ant-5_17_0-skeleton-header {
  display: flex;
  justify-content: center;
  align-items: center;
}
.perxis-auto-1_16_13-car-tile-table .perxis-auto-1_16_13-car-tile-table__skeleton.ant-5_17_0-skeleton.ant-5_17_0-skeleton-with-avatar .ant-5_17_0-skeleton-header .ant-5_17_0-skeleton-avatar {
  height: 18px;
  width: 18px;
}

.perxis-auto-1_16_13-car-tile-price {
  /* Typography */
  --perxis-auto-car-tile-price-current-font-family-inner: var(
    --perxis-auto-car-tile-price-current-font-family,
    var(--perxis-auto-price-current-font-family, var(--perxis-auto-root-typography-h3-font-family-inner))
  );
  --perxis-auto-car-tile-price-current-font-weight-inner: var(
    --perxis-auto-car-tile-price-current-font-weight,
    var(--perxis-auto-price-current-font-weight, var(--perxis-auto-root-typography-h3-font-weight-inner))
  );
  --perxis-auto-car-tile-price-current-letter-spacing-inner: var(
    --perxis-auto-car-tile-price-current-letter-spacing,
    var(--perxis-auto-price-current-letter-spacing, var(--perxis-auto-root-typography-h3-letter-spacing-inner))
  );
  --perxis-auto-car-tile-price-current-line-height-inner: var(
    --perxis-auto-car-tile-price-current-line-height,
    var(--perxis-auto-price-current-line-height, var(--perxis-auto-root-typography-h3-line-height-xxl-inner))
  );
  --perxis-auto-car-tile-price-current-text-transform-inner: var(
    --perxis-auto-car-tile-price-current-text-transform,
    var(--perxis-auto-price-current-text-transform, none)
  );
  --perxis-auto-car-tile-price-current-color-inner: var(
    --perxis-auto-car-tile-price-current-color,
    var(--perxis-auto-price-current-color, var(--perxis-auto-typography-color-darkest-inner))
  );
  --perxis-auto-car-tile-price-font-size-inner: var(
    --perxis-auto-car-tile-price-font-size,
    var(--perxis-auto-root-typography-super-small-font-size-xxl-inner)
  );
  --perxis-auto-car-tile-price-discount-price-font-size-inner: var(
    --perxis-auto-car-tile-price-discount-price-font-size,
    var(--perxis-auto-root-typography-h4-font-size-xxl-inner)
  );
  /* End Typography */
}
.perxis-auto-1_16_13-car-tile-price .perxis-auto-1_16_13-car-tile-price__price.perxis-auto-1_16_13-price {
  --perxis-auto-price-current-font-family: var(--perxis-auto-car-tile-price-current-font-family-inner);
  --perxis-auto-price-current-font-size: var(--perxis-auto-car-tile-price-discount-price-font-size-inner);
  --perxis-auto-price-current-font-weight: var(--perxis-auto-car-tile-price-current-font-weight-inner);
  --perxis-auto-price-current-letter-spacing: var(--perxis-auto-car-tile-price-current-letter-spacing-inner);
  --perxis-auto-price-current-line-height: var(--perxis-auto-car-tile-price-current-line-height-inner);
  --perxis-auto-price-current-text-transform: var(--perxis-auto-car-tile-price-current-text-transform-inner);
  --perxis-auto-price-current-color: var(--perxis-auto-car-tile-price-current-color-inner);
  --perxis-auto-price-old-font-size: var(--perxis-auto-car-tile-price-font-size-inner);
}
.perxis-auto-1_16_13-car-tile-price .perxis-auto-1_16_13-car-tile-price__skeleton.ant-5_17_0-skeleton .ant-5_17_0-skeleton-input {
  width: 70%;
  height: 24px;
}

.perxis-auto-1_16_13-car-tile-price {
  --perxis-auto-car-tile-price-icon-color-inner: var(
    --perxis-auto-car-tile-price-icon-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-car-tile-price-icon-size-inner: var(
    --perxis-auto-car-tile-price-icon-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
}
.perxis-auto-1_16_13-car-tile-price__benefits {
  --perxis-auto-car-tile-price-tooltip-max-width-inner: var(
    --perxis-auto-car-tile-price-tooltip-max-width,
    385px
  );
  --perxis-auto-car-tile-price-tooltip-padding-inner: var(
    --perxis-auto-car-tile-price-tooltip-padding,
    18px
  );
}
.perxis-auto-1_16_13-car-tile-price__benefits.perxis-auto-1_16_13-tooltip.ant-5_17_0-tooltip {
  width: 100%;
  --perxis-auto-tooltip-max-width: var(--perxis-auto-car-tile-price-tooltip-max-width-inner);
  --perxis-auto-tooltip-padding: var(--perxis-auto-car-tile-price-tooltip-padding-inner);
}
@media (max-width: 576px) {
  .perxis-auto-1_16_13-car-tile-price__benefits.perxis-auto-1_16_13-tooltip.ant-5_17_0-tooltip {
    --perxis-auto-tooltip-max-width: none;
    padding: 0 2%;
  }
}
.perxis-auto-1_16_13-car-tile-price .perxis-auto-1_16_13-car-tile-price__benefits-icon.perxis-auto-1_16_13-typography {
  --perxis-auto-typography-color-darkest-inner: var(--perxis-auto-car-tile-price-icon-color-inner);
  --perxis-auto-icon-font-size: var(--perxis-auto-car-tile-price-icon-size-inner);
  display: flex;
  line-height: 1;
}

.perxis-auto-1_16_13-car-tile-payment {
  /* Typography */
  --perxis-auto-car-tile-payment-font-family-inner: var(
    --perxis-auto-car-tile-payment-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-car-tile-payment-font-size-inner: var(
    --perxis-auto-car-tile-payment-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-car-tile-payment-font-weight-inner: var(
    --perxis-auto-car-tile-payment-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-car-tile-payment-line-height-inner: var(
    --perxis-auto-car-tile-payment-line-height,
    var(--perxis-auto-root-typography-small-line-height-xxl-inner)
  );
  --perxis-auto-car-tile-payment-letter-spacing-inner: var(
    --perxis-auto-car-tile-payment-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-car-tile-payment-text-transform-inner: var(
    --perxis-auto-car-tile-payment-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  /* End Typography */
}
.perxis-auto-1_16_13-car-tile-payment .perxis-auto-1_16_13-car-tile-payment__payment.perxis-auto-1_16_13-price {
  --perxis-auto-price-current-font-family: var(--perxis-auto-car-tile-payment-font-family-inner);
  --perxis-auto-price-current-font-size: var(--perxis-auto-car-tile-payment-font-size-inner);
  --perxis-auto-price-current-font-weight: var(--perxis-auto-car-tile-payment-font-weight-inner);
  --perxis-auto-price-current-letter-spacing: var(--perxis-auto-car-tile-payment-letter-spacing-inner);
  --perxis-auto-price-current-line-height: var(--perxis-auto-car-tile-payment-line-height-inner);
  --perxis-auto-price-current-text-transform: var(--perxis-auto-root-typography-small-text-transform-inner);
}
.perxis-auto-1_16_13-car-tile-payment .perxis-auto-1_16_13-car-tile-payment__skeleton.ant-5_17_0-skeleton .ant-5_17_0-skeleton-input {
  width: 70%;
  height: 24px;
}

.perxis-auto-1_16_13-car-tile-markers {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.perxis-auto-1_16_13-car-tile-markers .perxis-auto-1_16_13-car-tile-markers__skeleton.ant-5_17_0-skeleton .ant-5_17_0-skeleton-input {
  min-width: 80px;
  height: 20px;
}

.perxis-auto-1_16_13-car-tile-markers__marker-tooltip {
  /* Typography */
  --perxis-auto-car-tile-markers-more-list-font-family-inner: var(
    --perxis-auto-car-tile-markers-more-list-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-car-tile-markers-more-list-font-size-inner: var(
    --perxis-auto-car-tile-markers-more-list-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-car-tile-markers-more-list-font-weight-inner: var(
    --perxis-auto-car-tile-markers-more-list-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-car-tile-markers-more-list-letter-spacing-inner: var(
    --perxis-auto-car-tile-markers-more-list-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-car-tile-markers-more-list-line-height-inner: var(
    --perxis-auto-car-tile-markers-more-list-line-height,
    var(--perxis-auto-root-typography-small-line-height-xxl-inner)
  );
  --perxis-auto-car-tile-markers-more-list-text-transform-inner: var(
    --perxis-auto-car-tile-markers-more-list-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  /* End Typography */
}
.perxis-auto-1_16_13-car-tile-markers__marker-tooltip .ant-5_17_0-tooltip-inner {
  font-family: var(--perxis-auto-car-tile-markers-more-list-font-family-inner);
  font-size: var(--perxis-auto-car-tile-markers-more-list-font-size-inner);
  font-weight: var(--perxis-auto-car-tile-markers-more-list-font-weight-inner);
  line-height: var(--perxis-auto-car-tile-markers-more-list-line-height-inner);
  text-transform: var(--perxis-auto-car-tile-markers-more-list-text-transform-inner);
  letter-spacing: var(--perxis-auto-car-tile-markers-more-list-letter-spacing-inner);
  padding: 6px 12px;
}

.perxis-auto-1_16_13-car-tile-markers__more-tooltip .ant-5_17_0-tooltip-inner {
  padding: 18px;
}

.perxis-auto-1_16_13-car-tile-markers__more-list {
  /* Typography */
  --perxis-auto-car-tile-markers-more-list-font-family-inner: var(
    --perxis-auto-car-tile-markers-more-list-font-family,
    var(--perxis-auto-root-typography-super-small-font-family-inner)
  );
  --perxis-auto-car-tile-markers-more-list-font-size-inner: var(
    --perxis-auto-car-tile-markers-more-list-font-size,
    var(--perxis-auto-root-typography-super-small-font-size-xxl-inner)
  );
  --perxis-auto-car-tile-markers-more-list-font-weight-inner: var(
    --perxis-auto-car-tile-markers-more-list-font-weight,
    var(--perxis-auto-root-typography-super-small-font-weight-inner)
  );
  --perxis-auto-car-tile-markers-more-list-letter-spacing-inner: var(
    --perxis-auto-car-tile-markers-more-list-letter-spacing,
    var(--perxis-auto-root-typography-super-small-letter-spacing-inner)
  );
  --perxis-auto-car-tile-markers-more-list-line-height-inner: var(
    --perxis-auto-car-tile-markers-more-list-line-height,
    2
  );
  --perxis-auto-car-tile-markers-more-list-text-transform-inner: var(
    --perxis-auto-car-tile-markers-more-list-text-transform,
    var(--perxis-auto-root-typography-super-small-text-transform-inner)
  );
  /* End Typography */
  --perxis-auto-car-tile-markers-more-list-type-inner: var(--perxis-auto-car-tile-markers-more-list-type, "—");
  list-style: none;
  margin: 0;
  padding-left: 1em;
}
.perxis-auto-1_16_13-car-tile-markers__more-list > li {
  font-family: var(--perxis-auto-car-tile-markers-more-list-font-family-inner);
  font-size: var(--perxis-auto-car-tile-markers-more-list-font-size-inner);
  font-weight: var(--perxis-auto-car-tile-markers-more-list-font-weight-inner);
  line-height: var(--perxis-auto-car-tile-markers-more-list-line-height-inner);
  text-transform: var(--perxis-auto-car-tile-markers-more-list-text-transform-inner);
  letter-spacing: var(--perxis-auto-car-tile-markers-more-list-letter-spacing-inner);
}
.perxis-auto-1_16_13-car-tile-markers__more-list > li:before {
  display: inline-block;
  content: var(--perxis-auto-car-tile-markers-more-list-type-inner);
  width: 1em;
  margin-left: -1em;
}

.perxis-auto-1_16_13-car-tile-gallery-wrapper {
  --perxis-auto-car-tile-gallery-padding-inner: var(--perxis-auto-car-tile-spots-padding, 10px);
  /* End Padding */
  /* Color */
  --perxis-auto-car-tile-gallery-stub-background-color-inner: var(
    --perxis-auto-car-tile-gallery-stub-background-color,
    #262626cc
  );
  /* End Color */
  position: relative;
  background-position: center;
  overflow: hidden;
  width: calc(100% + var(--perxis-auto-car-tile-gallery-padding-left-inner) + var(--perxis-auto-car-tile-gallery-padding-right-inner));
  left: calc(var(--perxis-auto-car-tile-gallery-padding-left-inner) * -1);
}
.perxis-auto-1_16_13-car-tile-gallery-wrapper::before {
  content: "";
  display: block;
  width: 100%;
  height: 0;
  padding-top: var(--perxis-auto-car-tile-gallery-padding-top-inner);
  border-radius: var(--perxis-auto-car-tile-gallery-border-radius-inner);
}
.perxis-auto-1_16_13-car-tile-gallery-wrapper-image {
  position: absolute;
  top: 0%;
  width: 100%;
  height: 100%;
  border-radius: var(--perxis-auto-car-tile-gallery-border-radius-inner);
}
.perxis-auto-1_16_13-car-tile-gallery-image {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  border-radius: var(--perxis-auto-car-tile-gallery-border-radius-inner);
}
.perxis-auto-1_16_13-car-tile-gallery-image-mobile {
  position: absolute;
  width: 100%;
  pointer-events: none;
  height: 100%;
  border-radius: var(--perxis-auto-car-tile-gallery-border-radius-inner);
}
.perxis-auto-1_16_13-car-tile-gallery-spots {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(100% - 2 * var(--perxis-auto-car-tile-gallery-padding-inner));
  height: 100%;
  z-index: 1;
  touch-action: pan-y;
}
.perxis-auto-1_16_13-car-tile-gallery-spots:hover {
  --perxis-auto-car-tile-gallery-spot-line-display: flex;
}
.perxis-auto-1_16_13-car-tile-gallery-spot {
  --perxis-auto-car-tile-gallery-spot-line-bottom-inner: var(--perxis-auto-car-tile-gallery-spot-line-bottom, 8px);
  --perxis-auto-car-tile-gallery-spot-line-height-inner: var(--perxis-auto-car-tile-gallery-spot-line-height, 2px);
  --perxis-auto-car-tile-gallery-spot-line-display-inner: var(--perxis-auto-car-tile-gallery-spot-line-display, none);
  --perxis-auto-car-tile-gallery-spot-line-gap-inner: var(--perxis-auto-car-tile-gallery-spot-line-gap, 4px);
  --perxis-auto-car-tile-gallery-spot-line-border-radius-inner: var(
    --perxis-auto-car-tile-gallery-spot-line-border-radius,
    10px
  );
  --perxis-auto-car-tile-gallery-spot-line-opacity-inner: var(--perxis-auto-car-tile-gallery-spot-line-opacity, 0.3);
  --perxis-auto-car-tile-gallery-spot-line-active-opacity-inner: var(
    --perxis-auto-car-tile-gallery-spot-line-active-opacity,
    1
  );
  --perxis-auto-car-tile-gallery-spot-line-background-color-inner: var(
    --perxis-auto-car-tile-gallery-spot-line-background-color,
    var(--perxis-auto-root-sixth-color-inner)
  );
  --perxis-auto-car-tile-gallery-spot-line-active-background-color-inner: var(
    --perxis-auto-car-tile-gallery-spot-line-active-background-color,
    var(--perxis-auto-root-sixth-color-inner)
  );
  display: var(--perxis-auto-car-tile-gallery-spot-line-display-inner);
  justify-content: center;
}
.perxis-auto-1_16_13-car-tile-gallery-spot:first-child {
  justify-content: flex-start;
}
.perxis-auto-1_16_13-car-tile-gallery-spot:last-child {
  justify-content: flex-end;
}
.perxis-auto-1_16_13-car-tile-gallery-spot--active {
  --perxis-auto-car-tile-gallery-spot-line-background-color: var(
    --perxis-auto-car-tile-gallery-spot-line-active-background-color-inner
  );
  --perxis-auto-car-tile-gallery-spot-line-opacity: var(
    --perxis-auto-car-tile-gallery-spot-line-active-opacity-inner
  );
}
.perxis-auto-1_16_13-car-tile-gallery-spot--visible {
  display: flex;
}
.perxis-auto-1_16_13-car-tile-gallery-spot-line {
  width: calc(100% - var(--perxis-auto-car-tile-gallery-spot-line-gap-inner));
  position: absolute;
  bottom: var(--perxis-auto-car-tile-gallery-spot-line-bottom-inner);
  border: none;
  background-color: var(--perxis-auto-car-tile-gallery-spot-line-background-color-inner);
  opacity: var(--perxis-auto-car-tile-gallery-spot-line-opacity-inner);
  height: var(--perxis-auto-car-tile-gallery-spot-line-height-inner);
  border-radius: var(--perxis-auto-car-tile-gallery-spot-line-border-radius-inner);
}
.perxis-auto-1_16_13-car-tile-gallery-stub {
  --perxis-auto-car-tile-gallery-stub-font-size-inner: var(--perxis-auto-car-tile-gallery-stub-font-size, 14px);
  --perxis-auto-car-tile-gallery-icon-color-inner: var(
    --perxis-auto-car-tile-gallery-icon-color,
    var(--perxis-auto-root-first-color-inner)
  );
  --perxis-auto-typography-color-darkest: var(
    --perxis-auto-car-tile-gallery-text-color,
    var(--perxis-auto-root-first-color-inner)
  );
  --perxis-auto-typography-main-font-size-xxs: var(--perxis-auto-car-tile-gallery-stub-font-size-inner);
  --perxis-auto-typography-main-font-size-xs: var(--perxis-auto-car-tile-gallery-stub-font-size-inner);
  --perxis-auto-typography-main-font-size-sm: var(--perxis-auto-car-tile-gallery-stub-font-size-inner);
  --perxis-auto-typography-main-font-size-md: var(--perxis-auto-car-tile-gallery-stub-font-size-inner);
  --perxis-auto-typography-main-font-size-lg: var(--perxis-auto-car-tile-gallery-stub-font-size-inner);
  --perxis-auto-typography-main-font-size-xl: var(--perxis-auto-car-tile-gallery-stub-font-size-inner);
  --perxis-auto-typography-main-font-size-xxl: var(--perxis-auto-car-tile-gallery-stub-font-size-inner);
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  border-radius: var(--perxis-auto-car-tile-gallery-border-radius-inner);
  background-color: var(--perxis-auto-car-tile-gallery-stub-background-color-inner);
}
.perxis-auto-1_16_13-car-tile-gallery-stub .perxis-auto-1_16_13-icon-photo {
  color: var(--perxis-auto-car-tile-gallery-icon-color-inner);
}

.perxis-auto-1_16_13-car-tile-status .perxis-auto-1_16_13-car-tile-status__content {
  width: fit-content;
  max-width: 100%;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
